<div class="container-fluid p-0">
  <!-- Seção de Edição em Massa -->
  @if (produtos.length > 0 && produtosSelecionados.size > 0) {
    <div class="alert alert-warning p-3 mb-3">
      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Ativo (Edição em Massa):</b></label>
          <select class="form-control form-control-sm" [(ngModel)]="edicaoEmMassa.ativo">
            <option [ngValue]="null">-- Não Alterar --</option>
            <option [ngValue]="true">Ativo</option>
            <option [ngValue]="false">Inativo</option>
          </select>
        </div>
        <div class="form-group col-sm-2">
          <label><b>% (Edição em Massa):</b></label>
          <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassa.percentual" placeholder="Ex: 10" />
        </div>
        <div class="form-group col-sm-2">
          <label><b>Tipo (Edição em Massa):</b></label>
          <select class="form-control form-control-sm" [(ngModel)]="edicaoEmMassa.tipo_calculo">
            <option value="">-- Não Alterar --</option>
            <option value="margem">Margem</option>
            <option value="desconto">Desconto</option>
          </select>
        </div>
        <div class="form-group col-sm-2">
          <label><b>Preço (Edição em Massa):</b></label>
          <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassa.preco" placeholder="Ex: 10.50" />
        </div>
        <div class="form-group col-sm-2">
          <label><b>Qtde Mín. (Edição em Massa):</b></label>
          <input class="form-control form-control-sm" type="number" [(ngModel)]="edicaoEmMassa.qtd_minima" placeholder="Ex: 0" />
        </div>
      </div>
      <div class="form-group d-flex align-items-start  gap-2">
        <button class="btn btn-warning btn_formulario" type="button" (click)="aplicarEdicaoEmMassa()">
          ⚙️ Aplicar em Massa ({{ produtosSelecionados.size }})
        </button>
        <button class="btn btn-secondary btn_formulario" type="button" (click)="limparEdicaoEmMassa()">
          Limpar
        </button>
      </div>
    </div>
  }

  <!-- Tabela de Produtos -->
  <div class="table-responsive">
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <!-- Checkbox Selecionar Todos -->
          <th class="text-center" style="width: 40px;">
            <input type="checkbox" [checked]="todosSelecionados" (change)="selecionarTodos()" />
          </th>

          <th></th>
          <th class="text-center tabela_borda">Código</th>
          <th class="tabela_borda">Descrição</th>
          <th class="text-center tabela_borda">Ativo</th>
          @if (exibirLote) {
            <th class="text-center tabela_borda">Lote</th>
          }
          <th class="text-center tabela_borda" style="cursor: pointer;">Qtde Mínima</th>
          <th class="text-center tabela_borda" style="cursor: pointer;">Tipo</th>
          <th class="text-center tabela_borda" style="cursor: pointer;">%</th>
          <th class="text-right tabela_borda">Custo: R$</th>
          <th class="text-right tabela_borda">Preço (Atual): R$</th>
          <th class="text-right tabela_borda" style="cursor: pointer;">Preço: R$</th>
          <th class="text-center tabela_borda" style="cursor: pointer;">Cota</th>
          <th class="text-right tabela_borda">Margem (%)</th>
        </tr>
      </thead>

      <tbody>
        @for (i of indicesVisiveis; track produtos[i]) {
          @let produto = produtos[i];
          <tr>
            <!-- Checkbox Selecionar -->
            <td class="text-center">
              <input type="checkbox" [checked]="estaProdutoSelecionado(i)" (change)="selecionarProduto(i)" />
            </td>
            <!-- Ícone de Editar -->
            <td class="text-center tabela_acao">
              <i class="fa fa-pencil btn_tabela_acao" placement="right" ngbTooltip="Alterar" (click)="editarItem.emit({codigo: produto.codigo, qtd_minima: produto.qtd_minima})"></i>
            </td>
            <!-- Código -->
            <td class="text-center tabela_borda">{{ produto.codigo }}</td>
            <!-- Descrição -->
            <td class="tabela_borda">{{ produto.name }}</td>
            <!-- Ativo -->
            <td class="text-center tabela_borda" (click)="iniciarEdicao(i, 'ativo')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'ativo')) {
                <span>
                  {{ produto.ativo ? 'Ativo' : 'Inativo' }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'ativo')) {
                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.ativo"
                  (blur)="finalizarEdicao(i, 'ativo')"
                  (keyup.enter)="finalizarEdicao(i, 'ativo')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus>
                  <option [ngValue]="true">Ativo</option>
                  <option [ngValue]="false">Inativo</option>
                </select>
              }
            </td>
            <!-- Lote -->
            @if (exibirLote) {
              <td class="text-center tabela_borda">{{ produto.nome_lote }}</td>
            }
            <!-- Qtde Mínima (Editável) -->
            <td class="text-center tabela_borda" (click)="iniciarEdicao(i, 'qtd_minima')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'qtd_minima')) {
                <span>
                  {{ produto.qtd_minima }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'qtd_minima')) {
                <input
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.qtd_minima"
                  (blur)="finalizarEdicao(i, 'qtd_minima')"
                  (keyup.enter)="finalizarEdicao(i, 'qtd_minima')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
            <!-- Tipo (Editável) -->
            <td class="text-center tabela_borda" (click)="iniciarEdicao(i, 'tipo_calculo')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'tipo_calculo')) {
                <span>
                  {{ produto.tipo_calculo === 'margem' ? 'Margem' : 'Desconto' }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'tipo_calculo')) {
                <select
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.tipo_calculo"
                  (blur)="finalizarEdicao(i, 'tipo_calculo')"
                  (keyup.enter)="finalizarEdicao(i, 'tipo_calculo')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus>
                  <option value="margem">Margem</option>
                  <option value="desconto">Desconto</option>
                </select>
              }
            </td>
            <!-- Percentual (Editável) -->
            <td class="text-center tabela_borda" (click)="iniciarEdicao(i, 'percentual')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'percentual')) {
                <span>
                  {{ produto.percentual }}%
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'percentual')) {
                <input
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.percentual"
                  (blur)="finalizarEdicao(i, 'percentual')"
                  (keyup.enter)="finalizarEdicao(i, 'percentual')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
            <!-- Custo -->
            <td class="text-right tabela_borda">{{ produto.custo != null ? (produto.custo | currency: 'BRL') : '—' }}</td>
            <!-- Preço (Atual) -->
            <td class="text-right tabela_borda">{{ produto.price | currency: 'BRL' }}</td>
            <!-- Preço (Editável) -->
            <td class="text-right tabela_borda" (click)="iniciarEdicao(i, 'preco')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'preco')) {
                <span>
                  {{ produto.preco | currency: 'BRL' }}
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'preco')) {
                <input
                  type="number"
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.preco"
                  (blur)="finalizarEdicao(i, 'preco')"
                  (keyup.enter)="finalizarEdicao(i, 'preco')"
                  (keyup.escape)="cancelarEdicao(i)"
                  autofocus />
              }
            </td>
            <!-- Cota (Editável) -->
            <td class="text-center tabela_borda" (click)="iniciarEdicao(i, 'cota_total')" style="cursor: pointer; padding: 0.25rem;">
              <!-- Modo Visualização -->
              @if (!estaEditando(i, 'cota_total')) {
                <span [ngClass]="{ 'text-muted': produto.cota_total == null }">
                  {{ produto.cota_total != null ? produto.cota_total : 'Sem limite' }}
                  @if (produto.cota_total != null && produto.cota_utilizada != null) {
                    <small class="text-muted d-block">usado: {{ produto.cota_utilizada }}</small>
                  }
                  @if (produto.cota_total != null) {
                    <button type="button"
                            class="btn btn-link btn-sm p-0 d-block mx-auto"
                            title="Ver log de uso desta cota"
                            (click)="abrirLogItem($event, produto)">
                      <i class="fas fa-history"></i> ver uso
                    </button>
                  }
                </span>
              }
              <!-- Modo Edição -->
              @if (estaEditando(i, 'cota_total')) {
                <input
                  type="number"
                  min="0"
                  step="1"
                  class="form-control form-control-sm"
                  [(ngModel)]="produto.cota_total"
                  (blur)="finalizarEdicao(i, 'cota_total')"
                  (keyup.enter)="finalizarEdicao(i, 'cota_total')"
                  (keyup.escape)="cancelarEdicao(i)"
                  placeholder="Sem limite"
                  autofocus />
              }
            </td>
            <!-- Margem (%) -->
            @if (produto.custo > 0 && produto.preco > 0) {
              <td class="text-right tabela_borda"
                [ngClass]="{ 'text-danger': (1 - (produto.custo / produto.preco)) * 100 < 0, 'text-success': (1 - (produto.custo / produto.preco)) * 100 >= 0 }">
                {{ ((1 - (produto.custo / produto.preco)) * 100) | number: '1.2-2' }}%
              </td>
            } @else {
              @if (produto.price > 0 && produto.preco > 0) {
                <td class="text-right tabela_borda"
                  [ngClass]="{ 'text-danger': (1 - (produto.price / produto.preco)) * 100 < 0, 'text-success': (1 - (produto.price / produto.preco)) * 100 >= 0 }">
                  {{ ((1 - (produto.price / produto.preco)) * 100) | number: '1.2-2' }}%
                </td>
              } @else {
                <td class="text-right tabela_borda">—</td>
              }
            }
          </tr>
        }
        @if (indicesVisiveis.length === 0) {
          <tr><td colspan="20" class="text-center text-muted py-3">Nenhum produto encontrado.</td></tr>
        }
      </tbody>
    </table>
  </div>

</div>
